module.exports = __webpack_public_path__ + "stylesheets/newsWebsite_8069354a1a6fdaf37d3f3a617e2bd3bb.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/newsWebsite.less
// module id = b/cW
// module chunks = 154